/*
 *
 * FamilyFreightSimulateForm api's
 *
 */
import axios from 'axios';

import envs from '../../../envs';

const domain = `${envs.PROTOCOL}://${envs.ENTRYPOINT}/api`;

export const endpoints = {
  list: (enrollmentSlug, productSlug, postCode) =>
    `${domain}/families/enrollments/${enrollmentSlug}/products/${productSlug}/freight/?postcode=${postCode}`,
};

/**
 * Documentation: https://eskolare.postman.co/collections/2024076-b4c9b27d-5a9d-4a78-8028-5ae10fe63a76?version=latest&workspace=33e9d0fe-9d33-47cf-ad90-a76a685364de#57bcbcb2-05f7-4718-83d4-493a56f8608e
 */

export function list({ enrollmentSlug, productSlug, postCode }) {
  const config = {
    method: 'get',
    url: endpoints.list(enrollmentSlug, productSlug, postCode),
  };
  return axios(config);
}
